import { Component, createElement } from 'react';
import { string, array, object, shape, bool } from 'prop-types';
import { ModuleRegistry } from 'react-module-container';
import componentName from './component-name';
import Root from './components/root/index';

class MarketingIntegration extends Component {
  static propTypes = {
    routeBaseName: string.isRequired,
    userId: string.isRequired,
    metaSiteId: string.isRequired,
    config: object.isRequired,
    embeddedIntegrations: shape({
      apiBaseUri: string.isRequired,
    }).isRequired,
    accountLanguage: string.isRequired,
    staticsUrl: string.isRequired,
    experiments: object.isRequired,
    widgets: array.isRequired,
    premium: shape({
      exist: bool.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    embeddedIntegrations: {
      apiBaseUri: 'https://www.wix.com/_api/wix-html-live-site-data-webapp/',
    },
  };

  constructor(props) {
    super(props);
    this.VIEW_ID = 'MARKETING_INTEGRATION_APP';
    ModuleRegistry.notifyListeners(
      'businessManager.viewStartLoading',
      this.VIEW_ID,
    );
  }

  componentDidMount() {
    setTimeout(() => {
      ModuleRegistry.notifyListeners(
        'businessManager.viewFinishedLoading',
        this.VIEW_ID,
      );
    });
  }

  render() {
    const {
      experiments,
      embeddedIntegrations,
      accountLanguage,
      routeBaseName,
      userId,
      metaSiteId,
      staticsUrl,
      widgets,
      premium,
      userPermissions,
    } = this.props;

    return createElement(Root, {
      apiBaseUrl: '/_api/marketing-integration/',
      basename: `${routeBaseName}${metaSiteId}/marketing-integration`,
      userId,
      metaSiteId,
      embeddedIntegrationsApiBaseUri: `https://${window.location.hostname}${embeddedIntegrations.apiBaseUri}`,
      i18n: {
        locale: accountLanguage,
        staticsBaseUrl: staticsUrl,
      },
      experiments,
      widgets,
      premium,
      locale: accountLanguage,
      userPermissions,
    });
  }
}

ModuleRegistry.registerComponent(componentName, () => MarketingIntegration);
